import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="container-centered py-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-800 font-serif text-base font-semibold text-white" aria-hidden="true">
                B
              </span>
              <span className="font-serif text-lg font-semibold text-slate-950">
                Business First Bank
              </span>
            </div>
            <p className="max-w-md text-sm leading-6 text-slate-600">
              Your trusted financial partner with secure, modern banking solutions.
              Experience the future of banking with our innovative digital services.
            </p>
            <p className="mt-4 text-sm text-slate-600">
              1-800-BANK-123 · 24/7 Support
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
              Banking Services
            </h2>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-slate-700 underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700">
                  Open Account
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Personal Banking
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Business Banking
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Online Banking
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
              Support & Security
            </h2>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Security Center
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">
                  Fraud Prevention
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-slate-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-slate-600">
            © {currentYear} Business First Bank. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">Privacy Policy</a>
            <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">Terms of Service</a>
            <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">Accessibility</a>
            <a href="#" className="text-sm text-slate-700 underline-offset-4 hover:underline">FDIC Insured</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
